import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=a61c7482&scoped=true&"
import script from "./interface.vue?vue&type=script&lang=js&"
export * from "./interface.vue?vue&type=script&lang=js&"
import style0 from "./interface.vue?vue&type=style&index=0&id=a61c7482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61c7482",
  null
  
)

/* custom blocks */
import block0 from "./interface.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports